import { axiosInstance as axios } from '@backrs_ui/grow-ui/src/core/axios';
import { DocumentType } from '@backrs_ui/grow-ui/src/models/models';

export async function checkForUserDocument(userId: number, documentType: DocumentType) {
  const { data } = await axios.get(`/api/check-user-has-document`, {
    params: {
      user_id: userId,
      document_type: documentType,
    },
  });

  return data;
}
